import { render } from "./InitialUwTopSummaryCard.vue?vue&type=template&id=2dd660fa&scoped=true"
import script from "./InitialUwTopSummaryCard.vue?vue&type=script&lang=js"
export * from "./InitialUwTopSummaryCard.vue?vue&type=script&lang=js"

import "./InitialUwTopSummaryCard.vue?vue&type=style&index=0&id=2dd660fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd660fa"]])

export default __exports__